import * as Cookies from "js-cookie";

export const errorHandler = (err) => {
  switch (err?.extensions?.code) {
    case "UNAUTHENTICATED":
      Cookies.remove("access_level");
      Cookies.remove("primary_account");
      return;

    default:
      return err;
  }
};
